import { LocationSummary } from "../../domain/auxilary/LocationSummary";
import configStore from "../../stores/ConfigStore";


export default class LocationsDataService {

    public static async searchAsync(query: string): Promise<LocationSummary[]> {
        const token = await configStore.getTokenAsync();

        return fetch(`${configStore.hosts.api}/locations/search?query=${query}&language=en-us`, {
            credentials: "omit",
            headers: {
                "Authorization": `bearer ${token}`,
                "Content-Type": "application/json",
            },
            method: "GET",
        })
        .then(e => e.json())
    }
}
